import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

export const Container = styled.div`
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    background-color: ${Colors.bgLight};
    color: ${Colors.commons.white};
    font-weight: lighter;
`;

export const Header = styled.div`
    position: absolute;
    top: 0;

    height: 5rem;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: ${Colors.primary[100]};

    font-size: 1rem;
`;

export const ContentArea = styled.div`
    height: 100%;
    width: 100%;
    padding-top: 5rem;
    padding-bottom: 8rem;
    flex: 1;
    overflow: hidden;
`;

export const ButtonsArea = styled.div`
    height: 7rem;
    width: 100%;
    margin-bottom: 2rem;

    display: flex;
    justify-content: center;
    align-items: center;

    gap: 1rem;
    
    padding: 1rem;
    box-sizing: border-box;
`;
